module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAALEgAACxIB0t1+/AAAABZ0RVh0Q3JlYXRpb24gVGltZQAxMC0xMC0yMJNt2akAAAAcdEVYdFNvZnR3YXJlAEFkb2JlIEZpcmV3b3JrcyBDUzVxteM2AAAAs0lEQVQ4ja2TMQoCMRBF3xcFr2Ehglt7Ais7Ow9g72HsPYCdIOgRLLZeQRDsrDyA3dgEjcGB7K4fpnnM/PkJicyMNtIvaGZ9YA6MAroAO0nPXIMlMEjwTdIm7e06yYaZzDXoOTzbwOP/T9BxeBnM4yrrGJxCirj2dQwewD3afnX6vt+BmU2AGTB2+s/AUdL7OAqDBbAACm9TogrYSqpkZlNglTmYai0zOzQcBj6X1Fhq+51f5PQrVk57fC8AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/topUser.png
// module id = 95
// module chunks = 0